module.exports = ["nou net",["%s sekonde gelede","%s sekondes gelede"],["%s minuut gelede","%s minute gelede"],["%s uur gelede","%s ure gelede"],["%s dag gelede","%s dae gelede"],["%s week gelede","%s weke gelede"],["%s maand gelede","%s maande gelede"],["%s jaar gelede","%s jaar gelede"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/af-ZA.json
// module id = uUVx
// module chunks = 1